module.exports = __webpack_public_path__ + "img/img8.32ce43e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img8.png
// module id = 183
// module chunks = 0